import { ICurrentApplicationService, ILoggerService, IStoreDispatchers } from '.';
import * as State from '../stateManagement';

export interface IStoreActionsService extends IStoreDispatchers {
    init(dispatch: Function);
    getDispatchers(): IStoreDispatchers
}

export class StoreActionsService implements IStoreActionsService {
    static serviceId = 'storeActionsService';

    actions: State.IActionStoreService;
    alarmCategories: State.IAlarmCategoriesStoreService;
    alarmEmails: State.IAlarmEmailStoreService;
    alarms: State.IAlarmStoreService;
    alarmTemplates: State.IAlarmTemplateStoreService;
    apiInformation: State.IApiInformationStoreService;
    application: State.IApplicationStoreService;
    approvalStrategy: State.IApprovalStrategyStoreService;
    approvalSettings: State.IApprovalSettingsStoreService;
    authentication: State.IAuthenticationStoreService;
    categories: State.ICategoryStoreService;
    connectionPoints: State.IConnectionPointStoreService;
    dashboards: State.IDashboardStoreService;
    dashboardUsers: State.IDashboardUserStoreService;
    digitalSets: State.IDigitalSetStoreService;
    digitalCorrespondanceTables: State.IDigitalCorrespondanceTableStoreService;
    globalNotifications: State.IGlobalNotificationsStoreService;
    groups: State.IGroupsStoreService;
    historianStorageConfiguration: State.IHistorianStorageConfigurationStoreService;
    identifiers: State.IIdentifiersStoreService;
    layout: State.ILayoutStoreService;
    mailingJobs: State.IMailingJobsStoreService;
    objectAccessRights: State.IObjectAccessRightsStoreService;
    userGroups: State.IUserGroupsStoreService;
    onlineUsers: State.IOnlineUsersStoreService;
    states: State.IStatesStoreService;
    tags: State.ITagStoreService;
    tasks: State.ITaskStoreService;
    templates: State.ITemplatesStoreService;
    tickets: State.ITicketStoreService;
    ticketStatuses: State.ITicketStatusStoreService;
    ticketTypes: State.ITicketTypesStoreService;
    triggers: State.ITriggerStoreService;
    triggerActions: State.ITriggerActionStoreService;
    validationPageConfigurations: State.IValidationPageConfigurationStoreService;
    valueViewModels: State.IValueViewModelStoreService;
    variables: State.IVariablesStoreService;
    users: State.IUserStoreService;

    static $inject = [
        // Dispatcher service
        'actionActionDispatcherService',
        'alarmCategoriesActionsDispatcherService',
        'alarmActionsDispatcherService',
        'alarmEmailActionDispatcherService',
        'alarmTemplateActionsDispatcherService',
        'apiInformationActionsDispatcherService',
        'applicationActionsDispatcherService',
        'approvalSettingsActionsDispatcherService',
        'approvalStrategyActionsDispatcherService',
        'authenticationActionsDispatcherService',
        'categoryActionsDispatcherService',
        'connectionPointActionDispatcherService',
        'dashboardActionDispatcherService',
        'dashboardUserActionsDispatcherService',
        'digitalSetActionDispatcherService',
        'digitalCorrespondanceTableActionDispatcherService',
        'globalNotificationsActionDispatcherService',
        'groupsActionDispatcherService',
        'historianStorageConfigurationActionsDispatcherService',
        'identifiersActionDispatcherService',
        'layoutActionDispatcherService',
        'mailingJobsActionDispatcherService',
        'objectAccessRightsActionDispatcherService',
        'userGroupsActionDispatcherService',
        'onlineUsersActionDispatcherService',
        'statesActionDispatcherService',
        'tagActionDispatcherService',
        'taskActionDispatcherService',
        'templatesActionDispatcherService',
        'ticketActionDispatcherService',
        'ticketStatusActionDispatcherService',
        'ticketTypesActionDispatcherService',
        'triggerActionDispatcherService',
        'triggerActionActionDispatcherService',
        'validationPageConfigurationActionDispatcherService',
        'valueViewModelActionDispatcherService',
        'variablesActionDispatcherService',
        'userActionDispatcherService',
        // Regular service
        'currentApplicationService',
        'loggerService'
    ];

    constructor(
        // Dispatchers
        private _actionsActionsDispatcherService: State.IActionActionDispatcherService,
        private _alarmCategoriesActionsDispatcherService: State.IAlarmCategoriesActionsDispatcherService,
        private _alarmActionsDispatcherService: State.IAlarmActionsDispatcherService,
        private _alarmEmailActionDispatcherService: State.IAlarmEmailActionDispatcherService,
        private _alarmTemplateActionsDispatcherService: State.IAlarmTemplateActionsDispatcherService,
        private _apiInformationActionsDispatcherService: State.IApiInformationActionsDispatcherService,
        private _applicationActionsDispatcherService: State.IApplicationActionsDispatcherService,
        private _approvalSettingsActionsDispatcherService: State.IApprovalSettingsActionsDispatcherService,
        private _approvalStrategyActionsDispatcherService: State.IApprovalStrategyActionsDispatcherService,
        private _authenticationActionsDispatcherService: State.IAuthenticationActionsDispatcherService,
        private _categoryActionsDispatcherService: State.ICategoryActionsDispatcherService,
        private _connectionPointActionDispatcherService: State.IConnectionPointActionDispatcherService,
        private _dashboardActionDispatcherService: State.IDashboardActionDispatcherService,
        private _dashboardUserActionsDispatcherService: State.IDashboardUserActionsDispatcherService,
        private _digitalSetActionDispatcherService: State.IDigitalSetActionDispatcherService,
        private _digitalCorrespondanceTableActionDispatcherService: State.IDigitalCorrespondanceTableActionDispatcherService,
        private _globalNotificationsActionDispatcherService: State.IGlobalNotificationsActionDispatcherService,
        private _groupsActionDispatcherService: State.IGroupsActionDispatcherService,
        private _historianStorageConfigurationActionsDispatcherService: State.IHistorianStorageConfigurationActionsDispatcherService,
        private _identifiersActionDispatcherService: State.IIdentifiersActionDispatcherService,
        private _layoutActionDispatcherService: State.LayoutActionDispatcherService,
        private _mailingJobsActionDispatcherService: State.IMailingJobsActionDispatcherService,
        private _objectAccessRightsActionDispatcherService: State.IObjectAccessRightsActionDispatcherService,
        private _userGroupsActionDispatcherService: State.IUserGroupsActionDispatcherService,
        private _onlineUsersActionDispatcherService: State.IOnlineUsersActionDispatcherService,
        private _statesActionDispatcherService: State.IStatesActionDispatcherService,
        private _tagActionDispatcherService: State.ITagActionDispatcherService,
        private _taskActionDispatcherService: State.ITaskActionDispatcherService,
        private _templatesActionDispactcherService: State.ITemplatesActionDispatcherService,
        private _ticketActionDispatcherService: State.ITicketActionDispatcherService,
        private _ticketStatusActionDispatcherService: State.ITicketStatusActionDispatcherService,
        private _ticketTypesActionDispatcherService: State.ITicketTypesActionDispatcherService,
        private _triggersActionDispatcherService: State.ITriggerActionDispatcherService,
        private _triggerActionsActionDispatcherService: State.ITriggerActionActionDispatcherService,
        private _validationPageConfigurationActionDispatcherService: State.IValidationPageConfigurationActionDispatcherService,
        private _valueViewModelActionDispatcherService: State.IValueViewModelActionDispatcherService,
        private _variablesActionDispatcherService: State.IVariablesActionDispatcherService,
        private _userActionDispatcherService: State.IUserActionDispatcherService,
        // Regular services
        private _currentApplicationService: ICurrentApplicationService,
        private _loggerService: ILoggerService
    ) {
    }

    getDispatchers(): IStoreDispatchers {
        return this;
    }

    init(dispatch: Function): IStoreActionsService {
        const assembly = {
            actions: this._actionsActionsDispatcherService.getDispatcher(dispatch).dispatcher,
            alarmCategories: this._alarmCategoriesActionsDispatcherService.getDispatcher(dispatch).dispatcher,
            alarmEmails: this._alarmEmailActionDispatcherService.getDispatcher(dispatch).dispatcher,
            alarms: this._alarmActionsDispatcherService.getDispatcher(dispatch).dispatcher,
            alarmTemplates: this._alarmTemplateActionsDispatcherService.getDispatcher(dispatch).dispatcher,
            apiInformation: this._apiInformationActionsDispatcherService.getDispatcher(dispatch).dispatcher,
            application: this._applicationActionsDispatcherService.getDispatcher(dispatch).dispatcher,
            approvalStrategy: this._approvalStrategyActionsDispatcherService.getDispatcher(dispatch).dispatcher,
            approvalSettings: this._approvalSettingsActionsDispatcherService.getDispatcher(dispatch).dispatcher,
            authentication: this._authenticationActionsDispatcherService.getDispatcher(dispatch).dispatcher,
            categories: this._categoryActionsDispatcherService.getDispatcher(dispatch).dispatcher,
            connectionPoints: this._connectionPointActionDispatcherService.getDispatcher(dispatch).dispatcher,
            dashboards: this._dashboardActionDispatcherService.getDispatcher(dispatch).dispatcher,
            dashboardUsers: this._dashboardUserActionsDispatcherService.getDispatcher(dispatch).dispatcher,
            digitalSets: this._digitalSetActionDispatcherService.getDispatcher(dispatch).dispatcher,
            digitalCorrespondanceTables: this._digitalCorrespondanceTableActionDispatcherService.getDispatcher(dispatch).dispatcher,
            globalNotifications: this._globalNotificationsActionDispatcherService.getDispatcher(dispatch).dispatcher,
            groups: this._groupsActionDispatcherService.getDispatcher(dispatch).dispatcher,
            historianStorageConfiguration: this._historianStorageConfigurationActionsDispatcherService.getDispatcher(dispatch).dispatcher,
            identifiers: this._identifiersActionDispatcherService.getDispatcher(dispatch).dispatcher,
            layout: this._layoutActionDispatcherService.getDispatcher(dispatch).dispatcher,
            mailingJobs: this._mailingJobsActionDispatcherService.getDispatcher(dispatch).dispatcher,
            objectAccessRights: this._objectAccessRightsActionDispatcherService.getDispatcher(dispatch).dispatcher,
            userGroups: this._userGroupsActionDispatcherService.getDispatcher(dispatch).dispatcher,
            onlineUsers: this._onlineUsersActionDispatcherService.getDispatcher(dispatch).dispatcher,
            states: this._statesActionDispatcherService.getDispatcher(dispatch).dispatcher,
            tags: this._tagActionDispatcherService.getDispatcher(dispatch).dispatcher,
            tasks: this._taskActionDispatcherService.getDispatcher(dispatch).dispatcher,
            templates: this._templatesActionDispactcherService.getDispatcher(dispatch).dispatcher,
            tickets: this._ticketActionDispatcherService.getDispatcher(dispatch).dispatcher,
            ticketStatuses: this._ticketStatusActionDispatcherService.getDispatcher(dispatch).dispatcher,
            ticketTypes: this._ticketTypesActionDispatcherService.getDispatcher(dispatch).dispatcher,
            triggers: this._triggersActionDispatcherService.getDispatcher(dispatch).dispatcher,
            triggerActions: this._triggerActionsActionDispatcherService.getDispatcher(dispatch).dispatcher,
            validationPageConfigurations: this._validationPageConfigurationActionDispatcherService.getDispatcher(dispatch).dispatcher,
            valueViewModels: this._valueViewModelActionDispatcherService.getDispatcher(dispatch).dispatcher,
            variables: this._variablesActionDispatcherService.getDispatcher(dispatch).dispatcher,
            users: this._userActionDispatcherService.getDispatcher(dispatch).dispatcher
        };

        return Object.assign(this, assembly);
    }
}